import base from './base';

const stockApi = dispatch => {
  return {
    async getShareholders(code, data) {
      return await base.privateApi(dispatch, {
        path: `/stock/management/${code}`,
        method: 'get',
        data,
      });
    },
    async getOverview(code) {
      const response = await base.privateApi(dispatch, {
        path: `/stock/overview/${code}`,
        method: 'get',
      });
      return response;
    },

    async getPriceHistory(code, dateDMY) {
      const response = await base.privateApi(dispatch, {
        path: `/stock/history/${code}/date=${dateDMY}`,
        method: 'get',
      });
      return response;
    },

    async removeRequest(requestId) {
      const response = await base.privateApi(dispatch, {
        path: `/request/${requestId}`,
        method: 'delete',
      });
      return response;
    },

    async getRequests() {
      const response = await base.privateApi(dispatch, {
        path: `/request/list`,
        method: 'get',
      });
      return response;
    },

    async requestNewStock(code) {
      const response = await base.privateApi(dispatch, {
        path: `/request/add/${code}`,
        method: 'get',
      });
      return response;
    },

    async getStockInfo(code) {
      const response = await base.privateApi(dispatch, {
        path: `/stock/basic_info/${code}`,
        method: 'get',
      });
      return response;
    },

    async getStockSameIndustry(code) {
      const response = await base.privateApi(dispatch, {
        path: `/stock/same_group/${code}`,
        method: 'get',
      });
      return response;
    },

    async getStockSameIndustryV2(code, data) {
      return await base.privateApi(dispatch, {
        path: `/stock/same_group/${code}`,
        method: 'post',
        data,
      });
    },
  };
};

export default stockApi;
